// Breakpoint width / breakpointChanged event 
function getActiveBreakpoint(width) {
  if(width > 768) {
    return 'desktop'
  } else if( width > 575) {
    return 'tablet'
  } else {
    return 'mobile'
  }
}

/*
  Dispatch windowResized on window resize
  Dispatch breakpointChanged on breakpoint change
*/
export default function(__CONVERDY__) {

  __CONVERDY__.breakpoint = getActiveBreakpoint(window.innerWidth)

  let resizeTimer;

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      let activeBreakpoint = getActiveBreakpoint(window.innerWidth)
      document.dispatchEvent(new CustomEvent('windowResized', {detail: window.innerWidth}))
      if(__CONVERDY__.breakpoint !== activeBreakpoint) {
        __CONVERDY__.breakpoint = activeBreakpoint
        document.dispatchEvent(new CustomEvent('breakpointChanged', {detail: __CONVERDY__.breakpoint}))
      } 
    }, 50)
  })


}

// End breakpoint code